"use client";

import { NotificationSoundHandler } from "@calcom/web/components/notification-sound-handler";
import { BillingProfileGate } from "@calcom/web/modules/billing-profile/components/BillingProfileGate";
import { WebPushProvider } from "@calcom/web/modules/notifications/components/WebPushContext";
import { ToastProvider } from "@coss/ui/components/toast";
import useIsBookingPage from "@lib/hooks/useIsBookingPage";
import { TrpcProvider } from "app/_trpc/trpc-provider";
import { SessionProvider } from "next-auth/react";
import CacheProvider from "react-inlinesvg/provider";
import { GeoProvider } from "./GeoContext";

type ProvidersProps = {
  isEmbed: boolean;
  children: React.ReactNode;
  nonce: string | undefined;
  country: string;
};
export function Providers({ isEmbed, children, country }: ProvidersProps) {
  const isBookingPage = useIsBookingPage();

  return (
    <GeoProvider country={country}>
      <SessionProvider>
        <TrpcProvider>
          <ToastProvider position="bottom-center">
            {!isEmbed && !isBookingPage && <NotificationSoundHandler />}
            {/* FEAT-087: gate post-login bloqueante para datos de facturación
                (BillingProfile). El componente decide internamente si renderiza
                el modal en base a session + path + status query. No se monta en
                booking pages (`isBookingPage`) ni en embeds. */}
            {!isEmbed && !isBookingPage && <BillingProfileGate />}
            {/* @ts-expect-error FIXME remove this comment when upgrading typescript to v5 */}
            <CacheProvider>
              <WebPushProvider>{children}</WebPushProvider>
            </CacheProvider>
          </ToastProvider>
        </TrpcProvider>
      </SessionProvider>
    </GeoProvider>
  );
}
